module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABHUlEQVQ4jZXTwSpEURzH8c9cM2TtCSg1jPAMsiBewW6KhZpsPMDYyIKIIhbKMyiLyTMoQ9koDyF1ZVjcc7muE+ZXp+75nfP9n//53/+p1M7bSppEE4sYDd4jrnCG++LmpPA9iEPcYgN1DIUxEbxbHGM4h6oF+BLz5XRKSrCK8ZBhmmew9w+4qDns5hEbIWq/WkMjkRVsoLSYooWRMFrBK2oAzSoWItE3cVCYH8gKt13at5BgLBLgIuKdRryxJGL2ozSRNUlZKxGvGfGeqrIOq5cWdvDu6yor2IoE6FRq5+0p3Pj5J/7SG2YTdHHSJyww3byIG+j0AV8H5vMxpVjCEXq/gL1w8nJgvr3GFOuYxj4e8Ipn3AVvRtbCLzn0AQ7CNUt19CQGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/点.png
// module id = tbWk
// module chunks = 1